import {i18n} from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.taskForm.fields.id'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.taskForm.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.taskForm.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
